import {
  type MetaFunction,
  type LoaderFunctionArgs,
  Link,
  useLoaderData,
} from 'react-router'
import { getUserId } from '#app/utils/auth.server.ts'
import { requireControlsToBeEnabled } from '#app/utils/controls.server.ts'
import { prisma } from '#app/utils/db.server.ts'
import { siteTitle } from '#app/utils/global.ts'

export async function loader({ request }: LoaderFunctionArgs) {
  requireControlsToBeEnabled()

  const currentUserId = await getUserId(request)

  const users = await prisma.user.findMany({
    select: {
      id: true,
      email: true,
      firstName: true,
      lastName: true,
      locale: true,
    },
  })

  return { currentUserId, users }
}

export default function TrainingControlRoute() {
  const data = useLoaderData<typeof loader>()
  const { currentUserId, users } = data

  return (
    <>
      <ul className="flex gap-3">
        <li>
          <Link to={'/controls'}>Controls</Link>
        </li>
        <li className="flex items-center gap-3">
          ▶️
          <span className="inline-flex items-center gap-1.5">Training</span>
        </li>
      </ul>
      <div className="my-6">
        <Link to={`/controls/training/${currentUserId}`}>Current user</Link>
      </div>
      <table className="my-6 w-full table-auto border-collapse border">
        <thead>
          <tr>
            <th className="border p-2">ID</th>
            <th className="border p-2">Email</th>
            <th className="border p-2">First name</th>
            <th className="border p-2">Last name</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td className="border p-2">
                <Link to={`/controls/training/${user.id}`}>{user.id}</Link>
              </td>
              <td className="border p-2">{user.email}</td>
              <td className="border p-2">{user.firstName}</td>
              <td className="border p-2">{user.lastName}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

export const meta: MetaFunction = () => {
  return [{ title: `Controls > Training | ${siteTitle}` }]
}
